import { getNewbuildingRentTrapUrl } from './getNewbuildingRentTrapUrl';
import { IAppState } from '../common/state';

export const getNewbuildingFlatSaleTrapUrl = (state: IAppState): string => {
  return state.newbuildingFlatSaleQueryString || getNewbuildingRentTrapUrl(state);
};
